import { z } from 'zod';
import { SourceRefSchema, sourceOf } from '../schema_fields.ts';

// The air quality tile: CO₂, fine dust and VOC, coloured by how good they are.

export const AirQualityOptionsSchema = z.object({ source: sourceOf(SourceRefSchema, { gives: ['record'], label: 'Sensor' }) });
